/* eslint-disable */
import { formatObjectToString } from '@/core/helpers/formatter'
import Api from '@/repository/index'
import {
  addData,
  addParkData,
  fetchParkSettings,
  fetchParkSettingsFormulas,
  fetchParkSettingsMinMaxSum,
  getData,
  getParksData,
  getRetentionsMinMaxGlobal,
  putRetentionsMinMaxGlobal,
  removeParkData,
  selectParkData,
  updateParkSettings,
  updateParkSettingsMinMaxSum
} from '@/requests/settings'
import { showDefaultErrorMessage } from '@/utils/createMessage'
import { Message } from 'element-ui'

const state = {
  data: {},
  mileageService: {},
  retentionsMinMax: {},
  parks: [],
  isBaseLoading: true,
}

const getters = {

  getDefaultParkName: state =>
    state.parks.length
      ? state.parks.some(p => p.is_active === true)
        ? state.parks.find(p => p.is_active === true).name
        : 'Парк не выбран'
      : 'Нет парков',

  getDefaultParkId: state =>
    state.parks.length
      ? state.parks.some(p => p.is_active === true)
        ? state.parks.find(p => p.is_active === true).taxi_service_id
        : ''
      : '',

  getDefaultParkPk: state =>
    state.parks.length
      ? state.parks.some(p => p.is_active === true)
        ? state.parks.find(p => p.is_active === true).id
        : ''
      : '',

  getTaxometrLink: (_state, getters) =>
    driverId =>
      `https://fleet.taxi.yandex.ru/drivers/${driverId}/parks/${getters.getDefaultParkId}/card/`,
  getTaxometrLinkOrders: (_state, getters) =>
    driverId =>
      `https://fleet.taxi.yandex.ru/drivers/${driverId}/orders?park_id=${getters.getDefaultParkId}`,

  getRetentionTypes: state => (byName) => state.data?.retentionTypes?.reduce((acc, currentRetention) => {
    // Преобразовать массив типов удержаний в объект, где ключи - это, либо id, либо name, удержания (зависит от byName).

    if (byName) {
      const { name, ...retention } = currentRetention
      acc[name] = retention
    } else {
      const { id, ...retention } = currentRetention
      acc[id] = retention
    }

    return acc
  }, {}),
  getTransactionTypesToDropdown: state => {
    if (!state.data?.retentionTypes?.length) return []
    return state.data.retentionTypes
      .map(e => {
        return {
          description: e.description,
          name: e.name,
          id: e.id
        }
      })
  },
  autoExecRetentionIds: state => state.data.retentionTypes.filter(r => r.autoExec).map(r => r.id),
  getTimeZone: state => state?.data?.timeZone,

  driverSurchargeRetentionIds: state => state.data.retentionTypes.filter(r => r.driverSurcharge).map(r => r.id),

  fines: state => state.data.fines.reduce((acc, fines) => {
    // Преобразовать массив объектов fines, где в объекте только один ключ, в один объект
    const name = Object.keys(fines)
    acc[name] = fines[name]

    return acc
  }, {}),

  surcharges: state => state.data.surchargeTypes.reduce((acc, currentSurcharge) => {
    // Преобразовать массив типов доплат в объект, где ключи - это id доплаты.
    const { id, ...surcharge } = currentSurcharge
    acc[id] = surcharge

    return acc
  }, {}),
  getFuelTypes: state  => state.data.fuelTypes.reduce((acc, curr) => {
    const {id, ...surcharge} = curr
    acc[id] = surcharge

    return acc
  }, {}),

  surchargeSystem: state => state.data.surchargeSystemTypes.reduce((acc, curSurcharge) => {
    const { id, ...surcharge } = curSurcharge
    acc[id] = surcharge

    return acc
  }, {}),

  surchargesByName: state => state.data.surchargeTypes.reduce((acc, currentSurcharge) => {
    // Преобразовать массив типов доплат в объект, где ключи - это name доплаты.
    const { name, ...surcharge } = currentSurcharge
    acc[name] = surcharge

    return acc
  }, {}),
  mergeMinMaxRetentions: state => {
    if (!Object.keys(state.retentionsMinMax)?.length) return []
    const { mins, maxes } = state.retentionsMinMax
    const getNamesMin = mins.map(x => x.name)
    const getNamesMax = maxes.map(x => x.name)
    const mergeAndUnsetDublicats = [...new Set([...getNamesMin, ...getNamesMax])].filter(x => x !== '')
    if (!mergeAndUnsetDublicats?.length) return []
    return mergeAndUnsetDublicats.reduce((acc, value) => {
      const getMinValueByName = mins.filter(x => x.name === value).map(x => x.value)[0] || null
      const getMaxValueByName = maxes.filter(x => x.name === value).map(x => x.value)[0] || null
      acc = [...acc, { name: value, min: getMinValueByName || 0, max: getMaxValueByName || 0 }]
      return acc
    }, [])
  },
  getRetentionMinMaxById: state => id => {
    if (!id) return false
    const getRetentionNameById = state.data.retentionTypes.filter(x => x.id === id)
    if (!getRetentionNameById.length) return false
    const nameRetentionById = getRetentionNameById[0].name
    const getMaxRetentionByName = state.retentionsMinMax?.maxes?.filter(y => y.name === nameRetentionById)
    if (!getMaxRetentionByName?.length) return false
    return getMaxRetentionByName[0]?.value
  }
  // getRetentionNameMinMaxById: state => name => {
  //   if (!name) return false
  //   const getMaxRetentionByName = state.retentionsMinMax.max.filter(y => y.name === name)
  //   if (!getMaxRetentionByName.length) return false
  //   return getMaxRetentionByName[0]
  // }
}

const mutations = {
  SET: (state, data) => {
    state.data = data
  },
  UPDATE_SETTIGNS: (state, data) => {
    state.data = {
      ...state.data,
      ...data
    }
  },
  SET_DATA_PARK: (state, data) => {
    state.data = Object.assign(state.data, data)
  },
  SET_PARKS: (state, data) => {
    state.parks = data
  },
  ADD_PARK: (state, data) => {
    state.parks.push(data)
  },
  SET_RETENTIONS_MIN_MAX: (state, data) => {
    state.retentionsMinMax = data
  },
  SET_BASE_LOADING: (state, data) => {
    state.isBaseLoading = data
  },
  SET_MILEAGE_SERVICE: (state, data) => {
    state.mileageService = data
  }
}
const helpers = {
  convertSettingsFieldsToJSON: (settings) => {
    const { fines, minMaxRetentions, driversPercents, driversPercentsSelfEmployed } = settings

    const checkFieldAndConvert = (field) => {
      try {
        if (typeof field === 'string') return JSON.parse(field)
      } catch (error) {
        return field
      }
      return field
    }

    return {
      ...settings,
      fines: checkFieldAndConvert(fines),
      minMaxRetentions: checkFieldAndConvert(minMaxRetentions),
      driversPercents: checkFieldAndConvert(driversPercents),
      driversPercentsSelfEmployed: checkFieldAndConvert(driversPercentsSelfEmployed)
    }
  }
}
const actions = {

  async getCrmSettings ({ commit }) {
    await getData()
      .then(data => {
        if (typeof data.drivers_percents === 'string') {
          data.drivers_percents = JSON.parse(data.drivers_percents)
        }
        if (typeof data.fines === 'string') {
          data.fines = JSON.parse(data.fines)
        }
        commit('SET', data)
        return data
      })
      .catch((error) => {
        return error
      })

    await getParksData()
      .then(data => {
        commit('SET_PARKS', data)
        return data
      })
      .catch((error) => {
        return error
      })
    commit('SET_BASE_LOADING', false)
  },

  addPark ({ commit }, data) {
    addParkData(data).then(res => {
      commit('ADD_PARK', res)
      Message({
        message: 'Парк был добавлен',
        type: 'success',
        duration: 5 * 1000
      })
      return data
    })
      .catch((error) => {
        return error
      })
  },
  setDataPark ({ commit }, data) {
    console.log('setDataPark')
    commit('SET_DATA_PARK', data)
  },
  async putRetentionsMinMax ({ commit, state }, { settings_id, data, isEdit }) {
    try {
      const addParameterMaxToRetentions = state.retentionsMinMax?.max.map(x => {
        return {
          ...x,
          parameter: 'max'

        }
      }).filter(y => y.name !== data[0].name && isEdit)
      console.log('isEdit', isEdit)
      const res = await updateParkSettingsMinMaxSum(settings_id, [...data, ...addParameterMaxToRetentions])
      commit('SET_RETENTIONS_MIN_MAX', res)
      Message({
        message: 'Успешная операция!',
        type: 'success',
        duration: 5 * 1000
      })
      // commit('SET_CHANGES', StatisticShanges)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async fetchParkSettingsFormulas ({ commit, state }, settings_id) {
    try {
      const res = await fetchParkSettingsFormulas(settings_id)
      return res
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateMyavoAPICredentials ({ commit, state }, data) {
    try {
      const { myavoAccess, myavoRefresh } = state.data
      const res_myavo = await Api.parkManager.settings.getAllSettings({
        myavoAccess, myavoRefresh, ...data
      })
      commit('UPDATE_SETTIGNS', res_myavo)
      Message({
        message: 'Успешно обновленно!',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateTimeZone ({ commit, state }, timeZone) {
    try {
      const res_tz = await Api.parkManager.settings.updateTimeZone({
        timeZone
      })
      commit('UPDATE_SETTIGNS', res_tz)
      Message({
        message: 'Успешно обновленно!',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateYandexTaxiAPICredentials ({ commit, state }, data) {
    try {
      const { yandexTaxiApiKey, parkTaxiServiceId } = state.data
      const res_yandex = await Api.parkManager.settings.updateYandexTaxiAPICredentials({
        yandexTaxiApiKey, parkTaxiServiceId, ...data
      })
      commit('UPDATE_SETTIGNS', res_yandex)
      Message({
        message: 'Успешно обновленно!',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateFinesServiceKey ({ commit, state }, data) {
    try {
      const res_fines = await Api.parkManager.settings.updateFinesServiceKey({
        ...data
      })
      commit('UPDATE_SETTIGNS', res_fines)
      Message({
        message: 'Успешно обновленно!',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateRetentionBorders ({ commit, state }, data) {
    try {
      const { max, name } = data
      let maxesRetentions = state.retentionsMinMax.maxes
      const getFormatValue = {
        name,
        value: max
      }
      const getRetentionById = maxesRetentions.findIndex(x => x.name === name)

      if (getRetentionById >= 0 && max) {
        maxesRetentions[getRetentionById] = getFormatValue
      }
      if (getRetentionById === -1 && max) {
        maxesRetentions.push(getFormatValue)
      }
      if (!max) {
        maxesRetentions = maxesRetentions.filter(x => x.name !== name)
      }
      const response = await Api.parkManager.settings.updateRetentionBorders({
        maxes: maxesRetentions,
        regionParkId: state.data?.regionParkId
      })

      commit('SET_RETENTIONS_MIN_MAX', response)
      Message({
        message: 'Успешно обновленно!',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateCommonSettings ({ commit, state }, data) {
    try {
      const response = await Api.parkManager.settings.updateCommonSettings({
        ...data
      })
      commit('UPDATE_SETTIGNS', response)
      Message({
        message: 'Успешно обновленно!',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateDriversPercents ({ dispatch, state }, data) {
    try {
      await Api.parkManager.settings.updateDriversPercents(data)
      await dispatch('getAllSettings', { regionParkId: data.regionParkId })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  /**
   * Обновление настроек арендного парка
   * @param {{regionParkId: string,startFullDay: number,bonusIsTip: number,washerSum: number,internalInsurance: number,companyProfit: number,depositSum: number,finesServiceSum: string,finesDiscountPercent: string,timerWorkingIndicator: number,carsUpdateFrequency: number,maintenanceFrequency: number,workRuleIdForAutoCreateSifts: string}} data
   * @returns {Promise<any>}
   */
  async updateSettingsRent ({ dispatch, state }, data) {
    try {
      await Api.parkManager.settings.updateSettingsRent(data)
      await dispatch('getAllSettings', { regionParkId: data.regionParkId })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateFines ({ dispatch, state }, data) {
    try {
      await Api.parkManager.settings.updateFines(data)
      await dispatch('getAllSettings', { regionParkId: data.regionParkId })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async getAllSettings ({ commit, state }, data) {
    try {
      const [res_settings, res_perscents] = await Promise.all([
        Api.parkManager.settings.getAllSettings(data),
        Api.parkManager.settings.getDriversPercents(data)
      ])

      const getConvertedSettings = helpers.convertSettingsFieldsToJSON({
        ...res_settings,
        driversPercents: res_perscents?.driversPercents,
        driversPercentsSelfEmployed: res_perscents?.driversPercentsSelfEmployed
      })
      commit('SET', helpers.convertSettingsFieldsToJSON(getConvertedSettings))
      commit('SET_RETENTIONS_MIN_MAX', getConvertedSettings?.minMaxRetentions)
      return getConvertedSettings
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async getMileageService ({commit})  {
    try {
      const response = await Api.parkManager.settings.getServiceMileage()

      commit('SET_MILEAGE_SERVICE', response)

      return  response
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateMileageService ({}, data) {
    try {
      await Api.parkManager.settings.updateServiceMileage(data)

      Message({
        message: 'способ сбора пробега успешно изменен!',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async getAllSettingsReturn ({ commit, state }, data) {
    try {
      const res_settings = await Api.parkManager.settings.getAllSettings(data)
      const res_perscents = await Api.parkManager.settings.getDriversPercents(data)

      const getConvertedSettings = helpers.convertSettingsFieldsToJSON({
        ...res_settings,
        driversPercents: res_perscents?.driversPercents,
        driversPercentsSelfEmployed: res_perscents?.driversPercentsSelfEmployed
      })

      return getConvertedSettings
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async getRetentionsMinMax ({ commit, state }, id) {
    try {
      await fetchParkSettingsMinMaxSum(id)
        .then(data => {
          commit('SET_RETENTIONS_MIN_MAX', data)
          return data
        })
        .catch((error) => {
          showDefaultErrorMessage()
          return error
        })
      // commit('SET_CHANGES', StatisticShanges)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async getDriverPerscentsRegionPark ({ commit, state }, data) {
    try {
      const res_perscents = await Api.parkManager.settings.getDriversPercents(data)

      const getConvertedSettings = helpers.convertSettingsFieldsToJSON({
        driversPercents: res_perscents?.driversPercents,
        driversPercentsSelfEmployed: res_perscents?.driversPercentsSelfEmployed
      })
      return getConvertedSettings
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async getRetentionsMinMaxGlobal ({ commit, state }, id) {
    try {
      await getRetentionsMinMaxGlobal(id)
        .then(data => {
          commit('SET_RETENTIONS_MIN_MAX', data)
          return data
        })
        .catch((error) => {
          showDefaultErrorMessage()
          return error
        })
      // commit('SET_CHANGES', StatisticShanges)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async putRetentionsMinMaxGlobal ({ commit, state }, { data }) {
    try {
      const res = await putRetentionsMinMaxGlobal(data)
      commit('SET_RETENTIONS_MIN_MAX', res)
      Message({
        message: 'Успешная операция!',
        type: 'success',
        duration: 5 * 1000
      })
      // commit('SET_CHANGES', StatisticShanges)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async getRegionParkSettings ({ commit, state }, settings_id) {
    try {
      return await fetchParkSettings({ id: settings_id })
        .then(data => {
          return data[0]
        })
        .catch((error) => {
          showDefaultErrorMessage()
          return error
        })
      // commit('SET_CHANGES', StatisticShanges)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  async deleteRetentionsMinMax ({ commit, state }, { data, settings_id }) {
    try {
      const addParameterMaxToRetentions = state.retentionsMinMax?.max.map(x => {
        return {
          ...x,
          parameter: 'max'

        }
      }).filter(y => y.name !== data.name)
      console.log(addParameterMaxToRetentions)
      const res = await updateParkSettingsMinMaxSum(settings_id, [...addParameterMaxToRetentions])
      commit('SET_RETENTIONS_MIN_MAX', res)
      // const res = await deleteRetentionsMinMax(data)
      // commit('SET_RETENTIONS_MIN_MAX', res)
      Message({
        message: 'Вы удалили удержание',
        type: 'success',
        duration: 5 * 1000
      })
      // commit('SET_CHANGES', StatisticShanges)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  removePark ({ commit }, id) {
    removeParkData(id).then(() => {
      getParksData()
        .then(data => {
          commit('SET_PARKS', data)
          Message({
            message: 'Вы удалили таксопарк',
            type: 'success',
            duration: 5 * 1000
          })
          return data
        })
        .catch((error) => {
          return error
        })
    })
      .catch((error) => {
        Message({
          message: 'Не удалось удалить таксопарк',
          type: 'success',
          duration: 5 * 1000
        })
        return error
      })
  },

  selectPark ({ commit }, id) {
    selectParkData(id).then(() => {
      getParksData()
        .then(data => {
          commit('SET_PARKS', data)
          Message({
            message: 'Вы изменили действующий таксопарк',
            type: 'success',
            duration: 5 * 1000
          })
          return data
        })
        .catch((error) => {
          return error
        })
    })
      .catch((error) => {
        Message({
          message: 'Не удалось изменить таксопарк',
          type: 'error',
          duration: 5 * 1000
        })
        return error
      })
  },

  createCrmSettings ({ commit }, data) {
    return new Promise((resolve, reject) => {
      addData(data).then(res => {
        Message({
          message: 'Настройки CRM были изменены',
          type: 'success',
          duration: 5 * 1000
        })
        resolve(data)
      }).catch(error => {
        Message({
          message: 'Ошибка',
          type: 'error',
          duration: 5 * 1000
        })
        reject(error)
      })
    })
  },
  updateParkSettings ({ commit }, { id, data }) {
    return new Promise((resolve, reject) => {
      updateParkSettings(id, data).then(res => {
        Message({
          message: 'Настройки были изменены',
          type: 'success',
          duration: 5 * 1000
        })
        resolve(res)
      }).catch(error => {
        Message({
          message: 'Ошибка',
          type: 'error',
          duration: 5 * 1000
        })
        reject(error)
      })
    })
  },
  changePercentCrmSettings ({ commit, state }, data) {
    const dataSettings = { ...state.data }

    delete dataSettings.surcharges
    delete dataSettings.retentions

    dataSettings.drivers_percents.sort((prev, next) => Object.keys(prev)[0] - Object.keys(next)[0])

    const driversPercentsString = formatObjectToString(data)
    const finesString = formatObjectToString(dataSettings.fines)

    dataSettings.drivers_percents = driversPercentsString
    dataSettings.fines = finesString
    return new Promise((resolve, reject) => {
      addData(dataSettings).then(res => {
        Message({
          message: 'Настройки CRM были изменены',
          type: 'success',
          duration: 5 * 1000
        })
        resolve(dataSettings)
      }).catch(error => {
        Message({
          message: 'Ошибка',
          type: 'error',
          duration: 5 * 1000
        })
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
